import React from 'react';
import { BookOpen, Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  return <section className="py-12 bg-rose-50 overflow-hidden" data-id="element-183">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-185">
          {/* Product Image */}
          <div className="w-full lg:w-1/2 order-2 lg:order-1" data-id="element-186">
            <div className="relative mx-auto max-w-md" data-id="element-187">
              <div className="absolute inset-0 bg-white rounded-full filter blur-3xl opacity-40 animate-pulse" data-id="element-188"></div>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1dhEEACXLeTuuWmS8mGqro/ChatGPT_Image_27_nov_2025%2C_09_39_41_p.m..png" alt="Libro Chamba Digital" className="relative z-10 w-full rounded-lg shadow-2xl transform rotate-[-2deg] hover:rotate-0 transition-all duration-500" data-id="element-189" />
            </div>
          </div>

          {/* Content */}
          <div className="w-full lg:w-1/2 order-1 lg:order-2" data-id="element-190">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full text-rose-600 font-semibold text-sm mb-6 shadow-sm" data-id="element-191">
              <BookOpen className="w-4 h-4" data-id="element-192" />
              Tu nuevo mapa
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-warm-900 mb-6" data-id="element-193">
              Te presento <br data-id="element-194" />
              <span className="text-rose-600" data-id="element-195">
                "Chamba Digital para Mexicanas"
              </span>
            </h2>

            <p className="text-lg text-warm-700 mb-8 leading-relaxed" data-id="element-196">
              Una guía rápida, honesta y aterrizada diseñada para que construyas
              tu primer ingreso extra digital usando solo su celular. No es un
              curso eterno. No es motivación con glitter. Es tu mapa del metro
              digital.
            </p>

            <div className="space-y-4 mb-10" data-id="element-197">
              {['7 rutas claras (side hustles) para México', 'Explicado en español normal, sin tecnicismos', 'Cuánto cobrar de forma realista', 'Guiones de WhatsApp listos para copiar y pegar', 'Checklist de seguridad anti-estafas'].map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-198">
                  <div className="mt-1 bg-rose-200 p-1 rounded-full" data-id="element-199">
                    <Check className="w-3 h-3 text-rose-700" data-id="element-200" />
                  </div>
                  <span className="text-warm-800 font-medium" data-id="element-201">{feature}</span>
                </div>)}
            </div>

            <CTAButton onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-202">
              Quiero empezar ahora
            </CTAButton>
          </div>
        </div>
      </div>
    </section>;
}